<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">Acknowledgments</p>
<p class="txt">This book is a project I’ve wanted to do for the past several years, and it has been wonderful to see it come to life! <i>Patchwork City</i> would not have been possible without the help and support of my friends and family. Thank you, in particular, to Violet Craft, Jen Carlton Bailly, Monica Solorio Snow, Amber Wilson, and Jaime Young. You’re all amazing, and I’ll never be able to thank you enough for all the ways you helped me during the production of this book.</p>
<p class="txt">I also want to thank my favorite local fabric shops: Bolt, Cool Cottons, and Modern Domestic. We’re so lucky to have such fabulous shops in Portland!</p>
<p class="txt">Thank you, Krista Withers, for the beautiful longarm quilting on <span href="#/84_chapter80#HLD93" title="Link target outside of Sample"><i>Uptown</i></span> (page 165). All other sewing and quilting was done by me on my Janome 1600P-QC.</p>
<p class="txt">Thank you to Robert Kaufman Fabrics for providing Kona Cotton and Essex Linen solids for the quilts in this book, and to Michael Miller Fabrics for providing print fabrics for the <i>Uptown</i> quilt.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_book.vue?5ab00e6c